import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-white px-4 py-4" data-id="element-69" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto flex max-w-3xl items-start gap-3 rounded-lg border-2 border-ev-green bg-ev-paper p-3.5" data-id="element-70" data-mp="1o33s8bhenif4">
        <ShieldCheckIcon aria-hidden="true" className="h-9 w-9 shrink-0 text-[#2E7D46]" data-id="element-71" data-mp="221bw73cuzjzs" />
        <div data-id="element-72" data-mp="1x54trkjo8qml">
          <h2 className="mb-1 font-display text-[19px] leading-tight text-ev-black sm:text-2xl" data-id="element-73" data-mp="1x2ilfioyi73b">
            Your Purchase Is 100% Protected
          </h2>
          <p className="text-[13px] font-medium leading-snug text-ev-black/75 sm:text-[15px]" data-id="element-74" data-mp="14gz4qlll4fgy">
            Explore EV &amp; HYBRID DIAGNOSTIC PRO™ for 7 days. Access the complete 6-module
            diagnostic system and all 5 professional bonuses. If it isn&apos;t right for you,
            contact us within 7 days for a full refund according to the refund terms.
          </p>
        </div>
      </div>
    </section>;
}